import React from 'react';
import StatisticsProvider from '../../StatisticsProvider';
import useStatistics from '../../../../hooks/data/useStatistics';
import useHelpers from '../../../../hooks/context/useHelpers';
import HelperMethods from '../../../../services/exports/HelperMethods';
import Metric from '../../../../components/stats/Metric';
import MetricsContainer from '../../../../components/stats/MetricsContainer';
import RestaurantDirectory from './RestaurantDirectory';

function MobileApp({ dateRangeFilter, renderDateRangeFilter }) {
  return (
    <div className="space-y-4">
      {renderDateRangeFilter()}
      <StatisticsProvider
        mainMetrics={['gmv', 'mobile_app_gmv', 'mobile_app_average_order_value', 'mobile_app_orders_count']}
        mobileAppMetrics={['mobile_app_downloads']}
        dateRangeFilter={dateRangeFilter}
      >
        <Metrics />
      </StatisticsProvider>
      <RestaurantDirectory dateRangeFilter={dateRangeFilter} />
    </div>
  );
}

function Metrics() {
  const { stats, loadingMain, getMetricLabel, loadingMobileApp } = useStatistics();
  const { formatCurrency } = useHelpers();
  const getRevenuePercentageItems = () => {
    const value = HelperMethods.percentagePart(stats.mobile_app_gmv?.value.amount, stats.gmv?.value.amount) || 0;
    const previous =
      HelperMethods.percentagePart(stats.mobile_app_gmv?.previous.amount, stats.gmv?.previous.amount) || 0;
    const change = value - previous;

    return {
      value,
      previous,
      change,
    };
  };

  const getMobileAppDownloadsItems = () => {
    if (!stats.mobile_app_downloads) {
      return;
    }

    const change = HelperMethods.percentagePart(
      stats.mobile_app_downloads.value - stats.mobile_app_downloads.previous,
      stats.mobile_app_downloads.previous,
    );

    return {
      ...stats.mobile_app_downloads,
      change,
    };
  };

  const metrics = stats
    ? [
        <Metric
          key="mobile_app_downloads"
          name={getMetricLabel('mobile_app_downloads')}
          loading={loadingMobileApp}
          mainMetrics={['mobile_app_downloads']}
          items={getMobileAppDownloadsItems()}
        />,
        <Metric
          key="gmv"
          name={getMetricLabel('gmv')}
          loading={loadingMain}
          mainMetrics={['mobile_app_gmv']}
          items={stats.mobile_app_gmv}
          formatter={formatCurrency}
        />,
        <Metric
          key="mobile_app_gmv_percentage"
          name={getMetricLabel('mobile_app_gmv_percentage')}
          loading={loadingMain}
          mainMetrics={['mobile_app_gmv', 'gmv']}
          formatter={HelperMethods.formatPercentage}
          items={getRevenuePercentageItems()}
        />,
        <Metric
          key="mobile_app_orders_count"
          name={getMetricLabel('mobile_app_orders_count')}
          loading={loadingMain}
          mainMetrics={['mobile_app_orders_count']}
          items={stats.mobile_app_orders_count}
        />,
        <Metric
          key="mobile_app_average_order_value"
          name={getMetricLabel('mobile_app_average_order_value')}
          loading={loadingMain}
          mainMetrics={['mobile_app_average_order_value']}
          items={stats.mobile_app_average_order_value}
          formatter={formatCurrency}
        />,
      ]
    : [];

  return <MetricsContainer metrics={metrics} />;
}

export default MobileApp;
